import React from 'react'
import { WarningIcon } from 'icons';

const IconValueWarning = React.forwardRef((props, ref) =>
  <span {...props} ref={ref}>
    <WarningIcon {...props}/>
  </span>);

export default IconValueWarning;